<script setup>
import { useBlock, useProps } from '@/composables/useBlock.js'
import { useHint } from '@/composables/useHint.js'
import { useTracking } from '@/composables/useTracking.js'
import { defineAsyncComponent, onUpdated, ref } from 'vue'

const SvgWrapper = defineAsyncComponent(
  () => import('@/components/basic/atoms/SvgWrapper.vue')
)
const LoadingOverlay = defineAsyncComponent(
  () => import('@/components/basic/atoms/LoadingOverlay.vue')
)
const SingleTool = defineAsyncComponent(
  () => import('@/components/basic/molecules/SingleTool.vue')
)

const getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const [{ default: LozadHelper }, { elb }, { WALKER_COMMANDS }] =
      await Promise.all([
        await import('@/services/helpers/LozadHelper.js'),
        await import('@elbwalker/walker.js'),
        await import('@/services/helpers/ElbwalkerHelper')
      ])
    cache = { LozadHelper, elb, WALKER_COMMANDS }
    return cache
  }
})()

const props = defineProps(useProps())
const el = ref(null)

const { state, toggleAdminTools, retry } = useBlock(props)
useTracking(el)
const { showCmsHints } = useHint()

onUpdated(async () => {
  const { LozadHelper, elb, WALKER_COMMANDS } = await getModules()
  LozadHelper.hitLozad()
  elb(WALKER_COMMANDS.init, el.value)
})
</script>
<template>
  <div
    ref="el"
    v-if="state.value"
    class="cms-block position-relative"
    :class="{ striped: showCmsHints }"
    :data-reference-block="props.identifier"
    @mouseenter="toggleAdminTools"
    @mouseleave="toggleAdminTools"
  >
    <div class="block-content" v-html="state.value" />
    <SingleTool
      v-if="showCmsHints && state.id"
      class="mr-2"
      :display="state.displayTool"
      type="edit-cms-block"
      :id="state.id"
      :block-name="props.identifier"
    />
  </div>
  <span
    v-else-if="!state.requestFailed"
    class="position-relative loading"
    :class="{ striped: showCmsHints }"
  >
    <LoadingOverlay
      v-if="!props.disableAnimation"
      class="cms-block"
      width="40"
      height="40"
    />
  </span>
  <div v-else class="d-flex justify-center align-center">
    <span
      v-if="state.retryCount < state.maxRetryCount"
      class="cursor-pointer error replay"
      @click="retry"
    >
      <SvgWrapper use="icon_svg_replay" class="f-graphit" dimensions="30" />
    </span>
    <span v-else class="error" :class="{ 'd-none': props.hideOnError }">
      <SvgWrapper
        use="icon_svg_warning"
        class="f-form-warning"
        dimensions="30"
      />
    </span>
  </div>
</template>
